import { apiRequest } from './config'

export interface VapidPublicKeyResponse {
  publicKey: string
}

export interface PushStatusResponse {
  subscribed: boolean
  count: number
}

export const fetchVapidPublicKey = async (): Promise<string> => {
  const res = await apiRequest<VapidPublicKeyResponse>('/api/push/vapid-public-key')
  return res.publicKey
}

export const fetchPushStatus = async (): Promise<PushStatusResponse> => {
  return apiRequest<PushStatusResponse>('/api/push/status')
}

export interface SubscribePayload {
  endpoint: string
  keys: { p256dh: string; auth: string }
}

export const subscribePush = async (payload: SubscribePayload): Promise<void> => {
  await apiRequest<{ success: boolean }>('/api/push/subscribe', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export const unsubscribePush = async (endpoint: string): Promise<void> => {
  await apiRequest<{ success: boolean }>('/api/push/unsubscribe', {
    method: 'POST',
    body: JSON.stringify({ endpoint }),
  })
}
